<template>
  <v-container fluid style="color: #CCCCCC; min-width: 300px;" class="chart chart-move">
    <v-layout class="chart-tool">
      <loading :active.sync="summaryLoading"
        :can-cancel="false"
        color=#4ea397
        :width="25"
        :height="25"
        :opacity="0"
      />
      <!-- <v-flex v-if="editMode && field !== '@timestamp.keyword'" row>
        <v-spacer></v-spacer>
        <v-btn flat icon dark slot="activator" v-scroll-to="'#down'" @click="$emit('duplicate-chart', slice)">
          <v-tooltip bottom>
            <v-icon small slot="activator">file_copy</v-icon>
            <span>Duplicate Chart</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat icon dark slot="activator" @click="$emit('edit-chart', chartId)">
          <v-tooltip bottom>
            <v-icon small slot="activator">build</v-icon>
            <span>Edit Chart</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat icon dark slot="activator" @click="$emit('deleteChart', chartId)">
          <v-tooltip bottom>
            <v-icon small slot="activator">remove_circle_outline</v-icon>
            <span>Delete Chart</span>
          </v-tooltip>
        </v-btn>
      </v-flex> -->
      <v-layout v-if="editMode && field !== '@timestamp.keyword'" mt-2>
        <v-spacer />
        <v-menu
          transition="slide-y-transition"
          offset-y
          :close-on-content-click="false"
        >
            <template v-slot:activator="{ on }">
              <v-btn dark icon v-on="on" style="outline: none;" @click="action">
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile @click="$emit('duplicate-chart', slice)" v-scroll-to="'#down'">
                <v-icon size="16" style="color: #757575;">file_copy</v-icon>
                <v-list-tile-title style=" margin-left: 5px; color: #757575;">Duplicate</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="$emit('edit-chart', chartId)" >
                <v-icon size="16" style="color: #757575;">build</v-icon>
                <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Edit</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="$emit('deleteChart', chartId)" >
                <v-icon size="16" style="color: #757575;">remove_circle_outline</v-icon>
                <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Delete</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
      </v-layout>
    </v-layout>
    <v-flex class="text-xs-left" pt-0 pb-2>
      <h5 style="color: #CCCCCC; margin-top: 40px;">{{chartName}}</h5>
    </v-flex>
    <v-container
      fill-height
      fluid
      pa-0
      class="IgnoreFrom">
      <v-layout v-if="download !== '0.00 MB'">
        <v-flex row wrap pt-5>
          <v-flex pr-3 pl-3>
            <h3>{{upload}}</h3>
            <p>Upload</p>
          </v-flex>
          <v-flex pr-3 pl-3>
            <h3>{{download}}</h3>
            <p>Download</p>
          </v-flex>
          <v-flex pr-3 pl-3>
            <h3>{{count}}</h3>
            <p>Count</p>
          </v-flex>
        </v-flex>
      </v-layout>
      <v-layout v-else>
        <v-flex row wrap pt-5>
          <v-flex pr-3 pl-3>
            <h3>{{count}}</h3>
            <p>Count</p>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'XSummary',
  components: {
    Loading
  },
  props: {
    text: {
      type: String
    },
    user_index: {
      type: String
    },
    user_inst: {
      type: String
    },
    startTime: {
      type: [String, Number]
    },
    endTime: {
      type: [String, Number]
    },
    stores: {
      type: Array
    },
    subFilter: {
      type: String
    },
    valid: {
      type: Boolean
    },
    chartId: {
      type: String
    },
    chartName: {
      type: String,
      default: 'Untitle'
    },
    width: {
      type: [String, Number],
      default: '100%'
    },
    height: {
      type: [String, Number],
      default: '250px'
    },
    editMode: {
      type: Boolean,
      default: false
    },
    slice: {
      type: [Object]
    },
    index_now: {
      type: String
    },
    reloadchart: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    count: '',
    upload: '',
    download: '',
    // stores: [],
    sub: '',
    summaryLoading: false
  }),
  async created () {
    // await this.summary()
    if (!this.user_index) {
      this.user_index = this.index_now
    }
  },
  async mounted () {
    await this.summary()
    await this.beforeload()
  },
  methods: {
    async summary () {
      this.count = ''
      this.upload = ''
      this.download = ''
      this.summaryLoading = true
      if (this.subFilter !== '*' && this.text !== '') {
        this.sub = ''
        this.sub = `${this.subFilter} AND ${this.text}`
      } else if (this.subFilter !== '*') {
        this.sub = ''
        this.sub = `${this.subFilter}`
      } else {
      }
      let response = await axios.post(apiUrl + '/api/query/summary', {
        start: this.startTime,
        end: this.endTime,
        instance: this.user_inst,
        field: this.field,
        fieldsum: this.fieldsum,
        orderby: this.orderby,
        stores: this.stores,
        sub: this.sub,
        limit: this.topLimit,
        index: this.user_index,
        text: this.text
      })
      if (response) {
        if (response.data.hits.total === 0) {
          this.count = 'No Data'
          this.upload = 'No Data'
          this.download = 'No Data'
        } else {
          this.count = response.data.hits.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.upload = await this.convertUnit(response.data.aggregations.upload.value)
          this.download = await this.convertUnit(response.data.aggregations.download.value)
        }
      }
      this.summaryLoading = false
    },
    beforeload () {
      this.$emit('loadChart', 'load', 'x-summary')
    },
    convertUnit (byte) {
      let toGB = (byte / 1024 / 1024 / 1024)
      let convert = toGB > 1
        ? `${(byte / 1024 / 1024 / 1024).toFixed(2)} GB`
        : `${(byte / 1024 / 1024).toFixed(2)} MB`
      return convert
    },
    action () {
      this.$emit('actionToChart')
    }
  },
  watch: {
    startTime: {
      handler: function (startTime) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.summary()
      }
    },
    endTime: {
      handler: function (endTime) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.summary()
      }
    },
    stores: {
      handler: function (stores) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.summary()
      }
    },
    text: {
      handler: function (text) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.summary()
      }
    },
    user_index: {
      handler: function (user_index) {
        if (this.user_index) {
          this.summary()
        }
      }
    },
    index_now: {
      handler: function (user_index) {
        this.user_index = this.index_now
      }
    },
    reloadchart: {
      handler: function (val) {
        this.summary()
      }
    }
  }
}
</script>
<style scoped>
.IgnoreFrom {

}
</style>



// WEBPACK FOOTER //
// src/components/x-summary.vue